import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useWishlist } from "../context/WishlistContext";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import { BsTrash } from "react-icons/bs";

const Wishlist = () => {
  const { wishlist, removeFromWishlist } = useWishlist();
  const { addToCart } = useCart();
  const navigate = useNavigate();

  return (
    <Container className="py-5 mt-5">
      <h2 className="text-center fw-bold mb-4">❤️ Your Wishlist</h2>

      {wishlist.length === 0 ? (
        <div className="text-center">
          <p className="fs-5">Your wishlist is empty!</p>
          <Button variant="primary" onClick={() => navigate("/")}>
            Go Shopping 🛍️
          </Button>
        </div>
      ) : (
        <Row className="justify-content-center">
          {wishlist.map((product) => (
            <Col key={product._id} xs={12} sm={6} md={4} lg={3} className="mb-4">
              <Card className="border-0 shadow-lg p-3 bg-white rounded-4">
                <Card.Img
                  variant="top"
                  src={`https://madhusewingmachines.com/uploads/${product.images[0]?.url}`}
                  className="img-fluid rounded-3"
                  style={{ height: "230px", objectFit: "contain" }}
                />
                <Card.Body className="text-center">
                  <Card.Title className="fw-bold">{product.name}</Card.Title>
                  <Card.Text className="text-muted">{product.type}</Card.Text>
                  <h5 className="fw-bold text-primary">{product.price}</h5>

                  <Button
                    variant="primary"
                    className="mt-2 w-100"
                    onClick={() => addToCart(product)}
                    style={{ backgroundColor: "#25A1D5", border: "none" }}
                  >
                    Add to Cart
                  </Button>
                  <Button
                    variant="danger"
                    className="mt-2 w-100"
                    onClick={() => removeFromWishlist(product._id)} 
                  >
                    <BsTrash size={18} /> Remove
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};

export default Wishlist;
